export enum Roles {
  CUSTOMER = 1,
  FREELANCER = 2,
  RECRUITER = 3,
  JOB_SEEKER = 4,
}

export const USER_TYPE_CUSTOMER_PERSON = 1
export const USER_TYPE_CUSTOMER_COMPANY = 2

export enum CustomerTypes {
  INDIVIDUAL = USER_TYPE_CUSTOMER_PERSON,
  COMPANY = USER_TYPE_CUSTOMER_COMPANY,
}
